import * as React from "react";
import { cn } from "./cn";
import type { TypeListItemProps } from "./ListItemTypes";

/**
 * Tailwind CSS implementation of ListItem. Renders an <li> with the semantic
 * `seeds-list-item` class (plus `seeds-list-item-bordered` when isBordered)
 * from list.css — no runtime CSS-in-JS.
 *
 * The semantic class is placed before the consumer `className` so consumer
 * utilities can override the layered base styles.
 */
const ListItemTailwind = React.forwardRef<HTMLLIElement, TypeListItemProps>(
  ({ isBordered, children, className, ...rest }, ref) => {
    const classes = cn(
      "seeds-list-item",
      { "seeds-list-item-bordered": !!isBordered },
      className
    );

    return (
      <li
        ref={ref}
        className={classes}
        {...(rest as React.LiHTMLAttributes<HTMLLIElement>)}
      >
        {children}
      </li>
    );
  }
);

ListItemTailwind.displayName = "ListItem";

export default ListItemTailwind;
